export const PEB = 1;
export const PEB_Partiel = 11;
export const AUDIT = 3;
export const PEB_BOOST = 108;
export const ASBESTOS = 118;
export const ELEC = 4;
export const ELEC_REVISIT = 7;
export const ELEC_SUPP = 8;
export const ELEC_TEMPORARY_RECEPTION = 35;
export const ELEC_FINAL_RECEPTION = 36;
export const DISCOUNT = 5;
export const CITERNE_ENTERREE = 9;
export const EXTRA = 10;
export const CITERNE_AERIENNE = 6;
export const DEPLACEMENT = 13;
export const PLAN = 14;
export const GAZ_CONTROLE = 15;
export const GAZ_SUPP = 16;
export const GAZ_CONTROLE_PERIO = 100;
export const BLOWER_DOOR = 141;

export const ISO = 17;

export const DESCRIPTIF = 27;
export const PLAN3D = 26;
export const VISITE360 = 21;
export const VISITMATTERPORT = 113;
export const PHOTO = 18;
export const PHOTODRONE = 19;
export const VIDEO_DRONE = 101;
export const VIDEO = 20;
export const VIDEO_TEASING = 111;
export const QR = 112;
export const RESP_PEB = 22;
export const ELEC_NONDOM_MAX125A = 23;
export const ELEC_NONDOM_OVER125A = 24;
export const PEBCHAUFFAGE = 28;

export const PANELBIDDIT = 29;
export const PANELBIDDIT_SUPPORT = 30;
export const PANEL = 32;
export const PANEL_SUPPORT = 33;
export const SMS = 34;
export const ELEC_PHOTOVOLTA = 37;

export const PANEL_STANDARD = 102;
export const PANEL_XL_CERTI = 103;
export const PANEL_DEVIS = 104;

export const IMMOCOMBI = 50;
export const VISIOCOMBI = 51;
export const CONTROLECOMBI = 52;

export const PEB_SUPP = 11111;
// export const AUDIT_SUPP = 11112;

export const SPECIFIC = -1;
export const PLAQUETTE = -2;
export const VISIT = -5;
export const DESCRIPTIF_URBA = -6;
export const LIVRET = -7;
export const AFFICHETTE = -8;
export const AMIANTE = -11;
export const NETTMAISON = -13;
export const NETTJARDIN = -14;
export const VISITADVALORIS = 10023;
export const LOCKSMITH = 10024;
export const FRAIS_DOSSIER = -10;
export const URGENT_PRO = -12;
export const PRINT = -40;
export const PRINT_A_LA_CARTE = -41;
export const PRINT_A_LA_CARTE_BIS = -411;
export const PANEL_XL = -42;

export const OnlinePayment = 1001;
export const PublicationNotaireBE = 10000;
export const PublicationImmowebXL = 10001;
export const ImmovlanOnline = 10002;
export const NotaireBEOnline = 10003;
export const BidditOnline = 10004;
export const Fees = 10005;
export const BidditFees = 10006;
export const FullPress = 10007;
export const PublicationVlan = 10008;
export const PublicationLeSoir = 10009;
export const PublicationNiewsblad = 10010;
export const PublicationHetLaatsteNieuws = 10011;
export const publicationLaLibre = 10012;
export const PublicationDezeWeekRingBXL = 10013;
export const PublicationBruzz = 10014;
export const PublicationDeZondag = 10015;
export const PublicationRondomVlaamsBrabant = 10016;
export const PublicationRomdomPajottenland = 10017;
export const PublicationRondomNoordrant = 10018;
export const PublicationProximag = 10019;
export const PublicationEcho = 10020;
export const PublicationDeTijd = 10021;
export const PublicationDeMorgen = 10022;

export const PublicationAvenir = 10025;
export const PublicationProximagAndenne = 10026;
export const PublicationProximagCiney_Condroz = 10027;
export const PublicationProximagDinant_Bauraing = 10028;
export const PublicationProximagGembloux = 10029;
export const PublicationProximagNamur = 10030;
export const PublicationProximagPhilippeville = 10031;
export const PublicationProximagCouvinChimay = 10032;
export const PublicationProximagCiney_Dinant_Beauraing = 10033;
export const PublicationProximagCharleroi = 10034;
export const PublicationProximagBrabantWallonEst = 10035;
export const PublicationProximagHuy = 10036;
export const PublicationProximagHesbaye = 10037;
export const PublicationProximagFamenne = 10038;
export const PublicationProximagArdennes = 10039;

export const VisitGil4S = 10040;
export const VisitGil6S = 10041;
export const VisitGilBoundless_3M = 10042;
export const VisitGil2Times_Bid = 10043;
export const VisitGilBoundless_Bid = 10044;
export const VlanEditionLocal = 10045;

export const ProximagNamurBW = 10050;
export const ProximagLuxembourg = 10051;
export const ProximagLiege = 10052;
export const ProximagHainautOcc = 10053;
export const ProximagHainautOutOfOcc = 10054;
export const PublicationNotaireBeZimmo = 10055;
export const PublicationFbIns = 10056;
export const ZYVA = 99999;
export const FireLvl2Check = 44; // INCENDIE NIV 2 - Contrôle de conformité du système de détection incendie
export const FireLvl1Periodical = 45; // INCENDIE NIV 1 - Périodique système de détection incendie
export const FireCheckGasDetectors = 136; // INCENDIE - Contrôle détecteurs de gaz
export const FireCheckHoseReelAndHydrant = 137; // INCENDIE - Contrôle dévidoirs et hydrants
export const FireCheckEmergencyLighting = 138; // INCENDIE - Contrôle éclairage de secours
export const FireCheckSmokeEvacuation = 139; // INCENDIE - Contrôle des évacuations de fumée
export const FireLvl1Or2TestFireDetection = 140; // INCENDIE NIV 1 OU 2 - Test de détection incendie

export const Other = 0; // Valeur par défaut
export const Combi = 2; // NOT USED
export const Audit = 3; // AUDIT - Audit énergétique "officiel"
export const ElecLvl1Check = 4; // ELEC NIV1 - Contrôle de conformité domestique
export const OtherDiscount = 5; // AUTRE - Réduction
export const TankAAerial = 6; // CITERNE A - Aérienne
export const ElecLvl1Revisit = 7; // ELEC NIV1 - Revisite
export const ElecAdditionalElectricMeter = 8; // TO HIDE - ELEC - Compteur électrique supplémentaire
export const TankEBuried = 9; // CITERNE E - Enterrée
export const OtherExtra = 10; // AUTRE - Supplément
export const PEBPartial = 11; // PEB - Certificat PEB commun
export const OtherCancellation = 12; // AUTRE - Annulation
export const OtherTravel = 13; // AUTRE - Frais de déplacement
export const ImmoPlan2D = 14; // IMMO - Plan 2D
export const GasLvl1Check = 15; // GAZ NIV1 - Gaz naturel : contrôle de conformité < 70kw
export const GasAdditionalGasMeter = 16; // TO HIDE - GAZ -  Compteur de gaz supplémentaire
export const GasOptionIsometricPlan = 17; // GAZ OPTION ALL LVL - Plan isométrique
export const ImmoPicture = 18; // IMMO - Photos
export const ImmoPhotoPro = 19; // TO HIDE - IMMO - Vidéo drône
export const ImmoDescriptiveVideo = 20; // IMMO - Vidéo descriptive
export const ImmoVisit360 = 21; // IMMO - Visite virtuelle 360°
export const PEBAssessment = 22; // PEB - Étude PEB
export const ElecLvl3Check = 23; // ELEC NIV3 - Contrôle de conformité non domestique max 125A
export const ElecLvl4aPeriodical = 24; // ELEC NIV4A - Périodique/Plus de 125A
export const ElecLvl4bCheck = 25; // ELEC NIV4B - Contrôle de conformité
export const ImmoPlan3D = 26; // IMMO - Plan 3D
export const ImmoDescription = 27; // IMMO - Descriptif ( encodage d'annonce immobilière )
export const HeatingPEBType1 = 28; // CHAUFFAGE - PEB type 1 < 100kw
export const ImmoPanelSet = 29; // OLD PRODUCT - IMMO - Pack panneaux à coller
export const ImmoPanelSetSupport = 30; // OLD PRODUCT - IMMO - Pack panneaux avec support
export const ImmoPanelSetBig = 31; // OLD PRODUCT - IMMO - Pack panneaux XL
export const ImmoPanelSticker = 32; // IMMO - Pose panneau collé de l'étude
export const ImmoPanelSupport = 33; // IMMO - Pose panneau sur support
export const ImmoCodeSms = 34; // OLD PRODUCT - IMMO - Code SMS
export const ElecLvl1Temporary = 35; // ELEC NIV1 - Temporaire
export const ElecLvl1InstallationAcceptance = 36; // ELEC NIV1 - Réception installation
export const ElecLvl2Photovoltaic = 37; // ELEC NIV2 - Photovoltaïque
export const ElecLvl3Periodical = 38; // ELEC NIV3 - Périodique/Coffret de chantier
export const LiftingCheck = 39; // LEVAGE - Contrôle de conformité
export const LiftingPeriodical = 40; // LEVAGE - Périodique
export const AscenseursInspection = 41; // NOT USED
export const AscenseursRisk = 42; // NOT USED
export const AscenseursModif = 43; // NOT USED
export const ElecLvl6Check = 46; // ELEC NIV6 - Contrôle de conformité haute tension
export const ElecLvl5Periodical = 47; // ELEC NIV5 - Périodique haute tension
export const ElecLvl4bRiskAssessment = 48; // ELEC NIV4B - Analyse de risque
export const HeatingPEBType2 = 49; // CHAUFFAGE - PEB type 2 > 100kw
export const HeatingBoilerMaintenance = 50; // OLD PRODUCT - CHAUFFAGE - Entretien chaudière
export const GasLvl1Periodical = 100; // GAZ NIV1 - Gaz naturel : périodique < 70kw
export const ImmoPhotoVideoDrone = 101; // TO HIDE - IMMO - Vidéo descriptive avec vues drônes
export const PanelStandard = 102; // NOT USED
export const PanelXL = 103; // NOT USED
export const ImmoPanelCreation = 104; // IMMO - Fourniture/Création de panneaux
export const RealEstateExpertise = 105; // NOT USED
export const GasOptionLeakTesting = 106; // GAZ OPTION ALL LVL - Test d'étanchéité
export const ElecHTPerioNew = 107; // NOT USED
export const AuditMini = 108; // AUDIT - Audit PEB BOOST
export const GasLvl3Check = 109; // GAZ NIV3 - Gaz LPG : contrôle de conformité < 70kw
export const GasIndustrial = 110; // OLD PRODUCT
export const ImmoVideoTeasing = 111; // IMMO - Vidéo teasing
export const ImmoQRCode = 112; // IMMO - Code QR ( Fourniture et placement )
export const ImmoVisitMatterport = 113; // TO HIDE - IMMO - Visite Matterport
export const PEBOther = 114; // PEB - Certificat PEB autre
export const AuditOther = 115; // AUDIT - Audit autre
export const AuditThermography = 116; // AUDIT - Thermographie
export const AuditCertIBEau = 117; // AUDIT - Certificat EAU pour les bâtiments wallons
export const Asbestos = 118; // AMIANTE - Amiante
export const AsbestosSamples = 119; // AMIANTE - Prélèvement d'échantillons
export const AsbestosOther = 120; // AMIANTE - Autre
export const ElecLvl1Periodical = 121; // ELEC NIV1 - Périodique
export const ElecLvl1Other = 122; // ELEC NIV1 - Autre
export const ElecLvl2Other = 123; // ELEC NIV2 - Autre
export const ElecLvl3Other = 124; // ELEC NIV3 - Autre
export const ElecLvl4aOther = 125; // ELEC NIV4A - Autre
export const ElecLvl4bOther = 126; // ELEC NIV4B - Autre
export const ElecLvl5Other = 127; // ELEC NIV5 - Autre
export const ElecLvl6Other = 128; // ELEC NIV6 - Autre
export const TankAOther = 129; // CITERNE A - Autre
export const TankEOther = 130; // CITERNE E - Autre
export const GasLvl2Check = 131; // GAZ NIV2 - Gaz naturel : contrôle de conformité > 70kw
export const GasLvl2Periodical = 132; // GAZ NIV2 - Gaz naturel : périodique > 70kw
export const GasLvl3Periodical = 133; // GAZ NIV3 - Gaz LPG : périodique < 70kw
export const GasLvl4Check = 134; // GAZ NIV4 - Gaz LPG : contrôle de conformité > 70kw
export const GasLvl4Periodical = 135; // GAZ NIV4 - Gaz LPG : périodique > 70kw
export const BlowerDoorTest = 141; // AUDIT - Test d'étanchéité à l'air
export const TierPublicationNotaireBE = 10000; // TIER - notary
export const TierPublicationImmowebXL = 10001; // TIER
export const TierImmovlanOnline = 10002; // TIER
export const TierNotaireBEOnline = 10003; // TIER - same as 10000
export const TierBidditOnline = 10004; // TIER
export const TierFees = 10005; // TIER
export const TierBidditFees = 10006; // TIER
export const TierFullPress = 10007; // TIER
export const TierPublicationVlan = 10008; // TIER
export const TierPublicationLeSoir = 10009; // TIER
export const TierPublicationNiewsblad = 10010; // TIER
export const TierPublicationHetLaatsteNieuws = 10011; // TIER
export const TierPublicationLaLibre = 10012; // TIER
export const TierPublicationDezeWeekRingBXL = 10013; // TIER
export const TierPublicationBruzz = 10014; // TIER
export const TierPublicationDeZondag = 10015; // TIER
export const TierPublicationRondomVlaamsBrabant = 10016; // TIER
export const TierPublicationRomdomPajottenland = 10017; // TIER
export const TierPublicationRondomNoordrant = 10018; // TIER
export const TierPublicationProximag = 10019; // TIER
export const TierPublicationEcho = 10020; // TIER
export const TierPublicationDeTijd = 10021; // TIER
export const TierPublicationDeMorgen = 10022; // TIER
export const TierVisitAdValoris = 10023; // TIER
export const TierLocksmith = 10024; // TIER
export const TierPublicationAvenir = 10025; // TIER
export const TierPublicationProximagAndenne = 10026; // TIER
export const TierPublicationProximagCiney_Condroz = 10027; // TIER
export const TierPublicationProximagDinant_Bauraing = 10028; // TIER
export const TierPublicationProximagGembloux = 10029; // TIER
export const TierPublicationProximagNamur = 10030; // TIER
export const TierPublicationProximagPhilippeville = 10031; // TIER
export const TierPublicationProximagCouvinChimay = 10032; // TIER
export const TierPublicationProximagCiney_Dinant_Beauraing = 10033; // TIER
export const TierPublicationProximagCharleroi = 10034; // TIER
export const TierPublicationProximagBrabantWallonEst = 10035; // TIER
export const TierPublicationProximagHuy = 10036; // TIER
export const TierPublicationProximagHesbaye = 10037; // TIER
export const TierPublicationProximagFamenne = 10038; // TIER
export const TierPublicationProximagArdennes = 10039; // TIER
export const TierVisitGil4S = 10040; // TIER
export const TierVisitGil6S = 10041; // TIER
export const TierVisitGilBoundless_3M = 10042; // TIER
export const TierVisitGil2Times_Bid = 10043; // TIER
export const TierVisitGilBoundless_Bid = 10044; // TIER
export const TierVlanEditionLocal = 10045; // TIER
export const TierVisitBasic5 = 10046; // TIER - app visit | certinergie
export const TierVisitBasic10 = 10047; // TIER
export const TierVisitFix = 10048; // TIER
export const TierVisitConfort = 10049; // TIER
export const TierProximagNamurBW = 10050; // TIER - proximag | certinergie
export const TierProximagLuxembourg = 10051; // TIER
export const TierProximagLiege = 10052; // TIER
export const TierProximagHainautOcc = 10053; // TIER
export const TierProximagHainautOutOfOcc = 10054; // TIER
export const TierPublicationNotaireBeZimmo = 10055; // TIER
export const TierPublicationFbIns = 10056; // TIER
export const TierZimmoOnline = 10057; // TIER
